export default "__VITE_ASSET__Dz3vSntc__"